import React from "react";
import { Avatar, Col, Typography } from "antd";
import { CarOutlined, ClockCircleFilled } from "@ant-design/icons";
import "./VehicleRequested.css";
import { baseUrl } from "../../../../../commonUtils/commonUtils";
import { ReactComponent as DefaultIcon } from "../../../../../assets/icons/default.svg";

const { Text } = Typography;

const getLogisticsLabel = (channel) => {
  if (!channel) return "Vehicle";
  if (channel.startsWith("MOB")) return "MOB";
  if (channel.startsWith("YOUR")) return "Seller vehicle";
  return channel.replaceAll("_", " ");
};



const VehicleRequested = ({ requestData }) => {  
  const vehicles = requestData?.selected_vehicles || [];

  return (
    <Col className="requested-vehicle-container">
      <Text className="detail-heading">Vehicle requested</Text>
      <Text className="requested-vehicle-subtitle">
        These are the vehicle that has been requested by the seller. You can
        change the vehicle for efficient and fast shipping
      </Text>
      <Col className="requested-vehicle-strip">
        <Col className="requested-vehicle-strip-item">
          <CarOutlined />
          <Text>{getLogisticsLabel(requestData?.logistic_channel)}</Text>
        </Col>
        <Col className="requested-vehicle-strip-item">
          <ClockCircleFilled />
          <Text>Pickup at {requestData?.pickup_time_english || "N/A"}</Text>
        </Col>
      </Col>
      <Col className="requested-vehicle-list">
        {vehicles.map((vehicle, index) => {
          const vehicleInfo = vehicle?.vehicle_info || {};
          return (
            <Col className="requested-vehicle-row" key={vehicle?.id || index}>
              <Col className="requested-vehicle-left">
                <Avatar
                  className="requested-vehicle-avatar"
                  shape="square"
                  src={
                    vehicleInfo?.vechicle_image
                      ? `${baseUrl}${vehicleInfo?.vechicle_image}`
                      : undefined
                  }
                  icon={<DefaultIcon width={18} height={18} />}
                />
                <Col className="requested-vehicle-meta">
                  <Text className="requested-vehicle-type">
                    {vehicleInfo?.vechicle_type || "Vehicle"}
                  </Text>
                  <Col className="requested-vehicle-values">
                    <Text>{`Weight: ${
                      vehicleInfo?.vechicle_weight || "N/A"
                    }`}</Text>
                    <Text>{`Storage: ${
                      vehicleInfo?.vechicle_storage || "N/A"
                    }`}</Text>
                  </Col>
                </Col>
              </Col>
              <Text className="requested-vehicle-count">{vehicle?.count || 1}</Text>
            </Col>
          );
        })}
      </Col>
    </Col>
  );
};

export default VehicleRequested;
